export * from './language';
export * from './error';
export * from './paths';
export * from './patient-registration-fields'

export const 
  HTTP_HEADER_CONTENT_TYPE = 'Content-Type',
  HTTP_HEADER_AUTHORIZATION = 'Authorization',
  HTTP_HEADER_ESC_USER_DETAIL = 'esc-user-detail',
  HTTP_HEADER_ESC_TIMEZONE = 'esc-timezone',
  MIME_TYPE_JSON = 'application/json',
  URL_FORM_ENCODED = 'application/x-www-form-urlencoded',
  MULTIPART_FORM_DATA = 'multipart/form-data',

  DATETIME_FORMAT_FILE_PREFIX_S3 = "YYYYMMDDHHmmssSSS",
  DATE_FORMAT_EVENT_QUERY = "YYYY-MM-DD HH:mm:ss",
  DATE_FORMAT_YEAR_DAY_MONTH = "YYYY-MM-DD",

  PATTERN_LETTERS_WITH_SPACE = '^[a-zA-Z ]*$',
  PATTERN_ALPHA_NUMERIC_NO_SPACE = '^[a-zA-Z0-9-]*$',
  PATTERN_ALPHA_NUMERIC_WITH_SPACE = '^[a-zA-Z0-9- ]*$',
  PATTERN_ALPHA_NUMERIC_WITH_SPC_CHAR = '^[a-zA-Z0-9-_. ]*$',
  PATTERN_ALPHA_NUMERIC_WITH_SPACE_NO_OTHER_SPC_CHAR = '^[a-zA-Z0-9 ]*$',
  PATTERN_NUMERIC = '^[0-9]*$', 
  PATTERN_NUMERIC_DASH = '^[0-9-]*$', 
  PATTERN_EMAIL = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$', 
  // DEV NOTE: same as PATTERN_LETTERS_WITH_SPACE but does not allow whitespace only string eg. ' '
  //           allows whitespace at start, end, and within the string eg. ' value', 'value ', and 'va lue'
  PATTERN_LETTERS_WITH_RESTRICTED_WHITESPACE = /^(\s+[a-zA-Z ]+\s*)*(?!\s)[a-zA-Z ]*$/,
  PATTERN_CHARSET1_WITH_RESTRICTED_WHITESPACE = /^(\s+[a-zA-Z0-9 .,'’Ññ-]+\s*)*(?!\s)[a-zA-Z0-9 .,'’Ññ-]*$/,
  PATTERN_CHARSET1_WITH_RESTRICTED_WHITESPACE_WITHOUT_COMMA = /^(\s+[a-zA-Z0-9 .'’Ññ-]+\s*)*(?!\s)[a-zA-Z0-9 .'’Ññ-]*$/,
  PATTERN_CHARSET2_WITH_RESTRICTED_WHITESPACE = /^(\s+[a-zA-Z0-9 .,'’Ññ\-\/\$]+\s*)*(?!\s)[a-zA-Z0-9 .,'’Ññ\-\/\$]*$/,

  MAINTENANCE_AREA_FOLDERNAME = 'maintenance/area/upload',
  MAINTENANCE_BRANCH_FOLDERNAME = 'maintenance/branch/upload',
  MAINTENANCE_BRAND_FOLDERNAME = 'maintenance/brand/upload',
  MAINTENANCE_CAMPAIGN_FOLDERNAME = 'maintenance/campaign/upload',
  MAINTENANCE_CATEGORY_FOLDERNAME = 'maintenance/category/upload',
  MAINTENANCE_COMPANY_FOLDERNAME = 'maintenance/company/upload',
  MAINTENANCE_DEVICE_FOLDERNAME = 'maintenance/device/upload',
  MAINTENANCE_DISTRICT_FOLDERNAME = 'maintenance/district/upload',
  MAINTENANCE_ITEM_FOLDERNAME = 'maintenance/item/upload',
  MAINTENANCE_RECIPIENT_FOLDERNAME = 'maintenance/recipient/upload',
  MAINTENANCE_CHAIN_FOLDERNAME = 'maintenance/chain/upload',
  MAINTENANCE_GROUP_MASTER_FOLDERNAME = 'maintenance/group/list/upload',
  MAINTENANCE_GROUP_MAPPING_FOLDERNAME = 'maintenance/group/mapping/upload',
  MAINTENANCE_ROLE_FOLDERNAME = 'maintenance/role/upload',
  MAINTENANCE_WEBUSER_FOLDERNAME = 'maintenance/web_user/upload',
  MAINTENANCE_WEBUSER_RECIPIENT_FOLDERNAME = 'maintenance/web_user_recipient_mapping/upload',
  MAINTENANCE_PRICELIST_FOLDERNAME = 'maintenance/pricelist/upload',

  MAINTENANCE_WEBUSER_DOWNLOAD_FOLDERNAME = 'maintenance/web_user/download',

  PRICELIST_UPLOAD_FOLDERNAME = 'pricelist/upload',
  PRICELIST_UPLOAD_V2_FOLDERNAME = 'pricelist/upload_template',
  USER_ALLOC_UPLOAD_FOLDERNAME = 'user-allocation/upload',
  RECIPIENT_ALLOC_UPLOAD_FOLDERNAME = 'recipient-allocation/upload',

  SMS_PRICE = 0.50,

  SMS_DEFAULT_REGISTRATION_SUCCESS = "Coupon has been successfully registered.",
  SMS_DEFAULT_USER_ALREADY_REGISTERED = "Coupon is already registered to your Mobile Number.",
  SMS_DEFAULT_ANOTHER_USER_REGISTERED = "Coupon is already registered to another Mobile Number.",
  SMS_DEFAULT_USER_MAXED_COUPON = "Only 1 registered coupon allowed per Distribution.",

  OTP_TYPE_MOBILE = "mobile",
  OTP_TYPE_EMAIL = "email",
  OTP_TYPE_WHATSAPP = "whatsapp",

  PATREG_MODE_REG_NUM = "REG_NUM",
  PATREG_MODE_EMAIL = "EMAIL",
  PATREG_MODE_MOBILE = "MOBILE",
  PATREG_MODE_WHATSAPP = "WHATSAPP",
  PATIENT_SEARCH_SUCCESS = 'PATIENT_SEARCH_SUCCESS',
  PATIENT_SEARCH_BLOCKED = 'PATIENT_SEARCH_BLOCKED',

  // CONSENT CODES
  TERMS_CONDITION = 'TERMS_CONDITION',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  CALLS_TEXT = 'CALLS_TEXT',
  MARKETING = 'MARKETING',
  NEW_PATIENT = 'NEW_PATIENT',

  // RECIPIENT TYPES
  RECIPIENT_DOCTOR = 'DOC',
  RECIPIENT_BRANCH = 'BRCH',
  RECIPIENT_SOCIAL = 'SOC',

  UPLOAD_REFRESH_TIMEOUT = 3500
;